import { createLogic } from 'redux-logic';
import { TOKEN_CHECK_INTERVAL } from 'config/constants';
import { isExpiredGatekeeperToken } from 'lib/gatekeeperApi';
import { loadApplication } from 'store/application/actions';
import { getDecodedToken } from '../../selectors';
import { expireSBAAuthentication } from '../actions';

const monitorTokenExpiry = createLogic({
  type: loadApplication,
  warnTimeout: 0,
  process({ getState }, dispatch) {
    setInterval(() => {
      const state = getState();
      const token = getDecodedToken(state);

      if (token && isExpiredGatekeeperToken(token)) {
        dispatch(expireSBAAuthentication());
      }
    }, TOKEN_CHECK_INTERVAL);
  },
});

export default monitorTokenExpiry;
